import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { json } from "react-router-dom";
import {
 decrementCart,
 deleteCartItem,
 incrementCart,
} from "../Redux/Features/Card/actions";
import {
 prodQuetyDecrement,
 prodQuetyIncrement,
} from "../Redux/Features/ProductsPage/actions";

const CartItem = ({ details }) => {
 const products = useSelector((state) => state.allProducts);
 const dispatch = useDispatch();
 const [incrementDisable, setIncrementDisable] = useState({});
 const incrementBtn = useRef();
 const { id, name, category, prodQuantity, prodPrice, prodImg, stock } =
  details || {};

 const handleDisable = (type, id) => {
  products.map((prod) => {
   if (prod.id === id) {
    if (type === "increment") {
     setIncrementDisable(prod);
    }
    if (type === "decrement") {
     setIncrementDisable(prod);
    }
   }
  });
 };

 const handleIncrement = (id) => {
  handleDisable("increment", id);
  dispatch(prodQuetyDecrement(id));
  dispatch(incrementCart(id));
 };
 const handleDecrement = (id) => {
  handleDisable("decrement", id);
  dispatch(prodQuetyIncrement(id, 1));
  dispatch(decrementCart(id));
 };
 const handleDelete = (id, quantity) => {
  dispatch(deleteCartItem(id));
  dispatch(prodQuetyIncrement(id, quantity));
 };

 return (
  <div>
   <div className="cartCard">
    <div className="flex items-center col-span-6 space-x-6">
     {/* <!-- cart image --> */}
     <img className="lws-cartImage" src={prodImg} alt="product" />
     {/* <!-- cart item info --> */}
     <div className="space-y-2">
      <h4 className="lws-cartName">{name} </h4>
      <p className="lws-cartCategory">{category}</p>
      <p>
       BDT <span className="lws-cartPrice">{prodPrice}</span>
      </p>
     </div>
    </div>
    <div className="flex items-center justify-center col-span-4 mt-4 space-x-8 md:mt-0">
     {/* <!-- amount buttons --> */}
     <div className="flex items-center space-x-4">
      <button
       ref={incrementBtn}
       className="lws-incrementQuantity"
       onClick={() => handleIncrement(id)}
       // disabled={incrementDisable.prodQuantity === 1 ? true : false}
       disabled={Number(stock + 1) === prodQuantity}
      >
       <i className="text-lg fa-solid fa-plus"></i>
      </button>
      <span className="lws-cartQuantity">{prodQuantity}</span>
      <button
       className="lws-decrementQuantity"
       onClick={() => handleDecrement(id)}
       disabled={prodQuantity === 0}
      >
       <i className="text-lg fa-solid fa-minus"></i>
      </button>
     </div>
     {/* <!-- price --> */}
     <p className="text-lg font-bold">
      BDT{" "}
      <span className="lws-calculatedPrice">{prodPrice * prodQuantity}</span>
     </p>
    </div>
    {/* <!-- delete button --> */}
    <div className="flex items-center justify-center col-span-2 mt-4 md:justify-end md:mt-0">
     <button
      className="lws-removeFromCart"
      onClick={() => handleDelete(id, prodQuantity)}
     >
      <i className="text-lg text-red-400 fa-solid fa-trash"></i>
     </button>
    </div>
   </div>
  </div>
 );
};

export default CartItem;
